class ColorVariant extends HTMLElement {
  constructor() {
    super();
  }

}

class ColorTitle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const parent = this.closest('color-variant');
    const radios = parent.querySelectorAll('input');
    for(const [,i] of Object.entries(radios)) {
      if(i.checked) {
        this.setTitle(i.value);
      }
      i.addEventListener('change', this.handleSetTitle.bind(this));
    }
  }

  handleSetTitle(e) {
    const value = e.target.value;
    this.setTitle(value);
  }

  setTitle(value) {
    this.innerHTML = value.charAt(0).toUpperCase() + value.slice(1);
  }

}

customElements.define('color-variant', ColorVariant);
customElements.define('color-title', ColorTitle);